import { MdClose } from 'react-icons/md';
import './successToast.scss';
import { ToastSuccess } from '@src/assets/icons';

interface ISuccessToast {
  message: string;
  closeToast?: () => void;
}

const SuccessToast = ({ message, closeToast }: ISuccessToast) => {
  return (
    <div className="custom-toast-container">
      <div className="icon-wrapper">
        <ToastSuccess />
      </div>
      <span className="toast-message">{message}</span>
      <MdClose className="toast-close-icon" size={20} onClick={closeToast} />
    </div>
  );
};

export default SuccessToast;
